<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">TBA Participations</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Change Forms</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <b>NOTE: This Change Form is only available for Phase One</b>
        <br />
        <br />

        <router-link to="/change-form-request" class="btn btn-success mb-2"
          >Request Change Form</router-link
        >

        <!-- Pending -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Pending Change Forms</h4>
            <p>The table below shows the list of pending change forms.</p>
            <div class="table-responsive">
              <table
                id="pending_change_forms_table"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Projects</th>
                    <th>Description</th>
                    <th>Appoved By</th>
                    <th>Requested On</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(change, i) in pending_changes" v-bind:key="i">
                    <td>{{ change.id }}</td>
                    <td>{{ change.project }}</td>
                    <td>{{ change.description }}</td>
                    <td>{{ change.approved_by }}</td>
                    <td>{{ change.created_at }}</td>
                    <td>
                      <button
                        class="btn btn-warning"
                        data-toggle="modal"
                        data-target=".complete-change-form-modal"
                        @click="$store.commit('setChangeForm', change.id)"
                      >
                        Waiting For Response
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Completed -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Completed Change Forms</h4>
            <p>The table below shows the list of completed change forms.</p>
            <div class="table-responsive">
              <table
                id="completed_change_forms_table"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Projects</th>
                    <th>Description</th>
                    <th>Approved By</th>
                    <th>Requested On</th>
                    <th>Completed By</th>
                    <th>Action Taken</th>
                    <th>Completed At</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(change, i) in completed_changes" v-bind:key="i">
                    <td>{{ change.id }}</td>
                    <td>{{ change.project }}</td>
                    <td>{{ change.description }}</td>
                    <td>{{ change.approved_by }}</td>
                    <td>{{ change.created_at }}</td>
                    <td>{{ change.completed_by }}</td>
                    <td>{{ change.action_taken }}</td>
                    <td>{{ change.completed_at }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { setTimeout } from "timers";

export default {
  name: "change_forms",
  components: {},
  data() {
    return {
      pending_changes: [],

      completed_changes: []
    };
  },

  methods: {
    setChangeForm(id) {
      console.log(id);
      this.$store.commit("setChangeForm", id);
    },

    // load all purchases to save axios from keep making multiple queries in one page
    loadAllChangeForms() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        // Status "Paid(3)"
        axios
          .get("/change_form", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.pending_changes = res.data.pending;
            this.completed_changes = res.data.completed;
            this.destroyDatatable();
          })
          .then(function() {
            $("#completed_change_forms_table").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });
            $("#pending_change_forms_table").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4]
                  }
                }
              ]
            });
          });
      }
    },

    purchaseDetail(id) {
      return "/tba/details/" + id;
    },

    destroyDatatable() {
      $("#completed_change_forms_table")
        .DataTable()
        .destroy();
      $("#pending_change_forms_table")
        .DataTable()
        .destroy();
    }
  },

  mounted() {
    this.loadAllChangeForms();

    this.$root.$on("ChangeFormsLoadAllChangeForms", () => {
      // your code goes here
      this.loadAllChangeForms();
    });
  }
};
</script>
